module.exports = __webpack_public_path__ + "img/empty.cc55cc65.png";